const langtrans={
      zxjz:["最新进展","Operation progress"],
      sj:["事件","The case"],
      sjj:["时间","Time"],
      czkkxq:["查看详情","View details"]
}
export default langtrans;


// WEBPACK FOOTER //
// ./src/components/Tips_box/message_box.vue.trans.js